import {getStartOfWeek} from '@igp/shared/utils';
export const PlayerLevelReportV2ViewModelKeysTypeName = 'PlayerLevelReportV2ViewModelKeys';
export const PlayerLevelReportV2QueryItemsKeysTypeName = 'PlayerLevelReportV2QueryItemsKeys';
export const PlayerLevelReportV2QuerySummaryKeysTypeName = 'PlayerLevelReportV2QuerySummaryKeys';
export const PlayerLevelReportV2ColumnSettingKeysTypeName = 'PlayerLevelReportV2ColumnSettingKeys';
export const PlayerLevelReportV2SortKeysTypeName = 'PlayerLevelReportV2SortKeys';
export const PlayerLevelReportV2DownloadFieldsTypeName = 'PlayerLevelReportV2DownloadFields';
export const PlayerEcologySummaryModelTypeName = 'PlayerEcologySummaryModel';
export const PlayerEcologySummaryViewModelTypeName = 'PlayerEcologySummaryViewModel';
export const AgentPlayerReportingV2TypeName = 'AgentPlayerReportingV2TypeName';
export const PlayerLevelReportV2DownloadModelTypeName = 'PlayerLevelReportV2DownloadModel';

const availableWeekCount = 14; // ~ 3 months
export const firstAvailableDate = getStartOfWeek(availableWeekCount);
